export default () => ({
	billingCompanyDetails: [],
	billingCompanyDetailsMeta: {},
	billingCompanyDetail: {},
	billingSeriesPolicies: [],
	billingSeriesPolicy: {},
	billingSeriesPoliciesMeta: {},
	billingDocumentConfigs: [],
	billingDocumentConfig: {},
	billingDocumentConfigsMeta: {},
	billingDebetasDimensionDetail: {},
	billingDebetasDimensionDetails: [],
	billingDebetasDimensionHeader: {},
	billingDebetasDimensionHeaders: [],
	billingDebetasDimensionHeaderDataFields: [],
	billingRecords: [],
	billingRecord: {},
	billingRecordRelatedOrder: null,
	billingRecordsMeta: {},
	billingCashRegisters: [],
	billingCashRegister: {},
	billingCashRegistersMeta: {},
	billingCashRegisterSeriesPolicies: [],
	billingAccountingExportConfig: {},
	billingDocumentItemDescriptions: [],
	billingDocumentItemDescriptionsMeta: {},
	billingDocumentItemDescriptionGroups: [],
	billingDocumentItemDescriptionGroupsMeta: {},
	billingDocumentItemDescriptionGroup: {},
	searchFilters: {},
	loading: {
		billingCompanyDetails: false,
		billingCompanyDetail: false,
		billingCompanyDetailsMeta: false,
		billingSeriesPolicies: false,
		billingSeriesPolicy: false,
		billingSeriesPoliciesMeta: false,
		billingDocumentConfigs: false,
		billingDocumentConfig: false,
		billingDocumentConfigsMeta: false,
		billingDebetasDimensionDetail: false,
		billingDebetasDimensionDetails: false,
		billingDebetasDimensionHeader: false,
		billingDebetasDimensionHeaders: false,
		billingDebetasDimensionHeaderDataFields: false,
		billingRecords: false,
		billingRecord: false,
		billingRecordsMeta: false,
		billingCashRegisters: false,
		billingCashRegister: false,
		billingCashRegistersMeta: false,
		billingAccountingExportConfig: false,
		billingDocumentItemDescriptions: false,
		billingDocumentItemDescriptionsMeta: false,
		billingDocumentItemDescriptionGroups: false,
		billingDocumentItemDescriptionGroupsMeta: false,
		billingDocumentItemDescriptionGroup: false
	}
})
